import React from "react";

export const ArrivalCell = ({ checkInDate }: { checkInDate: Date }) => {
  return (
    <div className="text-sm text-center">
      <div>{new Date(checkInDate).toLocaleDateString("en-GB")}</div>
      <div className="text-xs text-gray-500">
        {new Date(checkInDate).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </div>
    </div>
  );
};
